import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck } from 'rxjs/operators';
const metroRegionsQuery = gql`query get_metro_regions{
  metro_regions{
    id
    name
    state_id
  }
}`;

@Injectable({
  providedIn: 'root'
})
export class MetroRegionsService {

  constructor(private apollo: Apollo) { }

  getMetroRegions(){
    return this.apollo.use('external').query({
      query: metroRegionsQuery
    }).pipe(pluck('data', 'metro_regions'))
  }
}
